import React, { useEffect, useMemo, useState } from 'react'
import { Dialog, DialogContent } from '@/components/ui/dialog'
import { debateToolModes } from '@/utils/common'
import { useMeetingAppContext } from '@/MeetingAppContextDef'
import { BallotStep } from './BallotStep'
import { BallotResults } from './BallotResults'
import { useHall } from '@/contexts/HallProvider'
import { useHallUsers } from '@/contexts/HallUsersProvider'

export const BallotModal: React.FC = () => {
  const { setDebateToolMode, debateToolMode } = useMeetingAppContext()
  const [currentStep, setCurrentStep] = useState(0)
  const [isAIProcessing, setIsAIProcessing] = useState(false)
  const { ballots } = useHall()
  const { currentUser } = useHallUsers()

  const backStep = () => setCurrentStep((prev) => prev - 1)
  const forwardStep = () => setCurrentStep((prev) => prev + 1)

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <BallotStep setIsAIProcessing={setIsAIProcessing} forwardStep={forwardStep} />
      case 1:
        return <BallotResults onBack={backStep} />
    }
  }

  const usersBallot = useMemo(() => {
    return ballots?.find((ballot) => ballot?.hallUserId === currentUser?.id)
  }, [ballots])

  useEffect(() => {
    if (usersBallot) setCurrentStep(1)

    return () => setCurrentStep(0)
  }, [usersBallot, debateToolMode])

  return (
    <Dialog
      open={debateToolMode === debateToolModes.BALLOT}
      onOpenChange={(open) => {
        if (!open) {
          setDebateToolMode(null)
          setCurrentStep(0)
        }
      }}
    >
      <div className="relative">
        <DialogContent className="dark:text-white max-h-[80vh] h-full  md:min-w-[600px] noScrollbar">
          {isAIProcessing && <div className="modal-ai-overlay rounded-md" />}
          {renderStep()}
        </DialogContent>
      </div>
    </Dialog>
  )
}
